export default {
  title: '素材リスト',
  playableTitle: 'プレイアブル広告',
  materialTitle: '画像＆動画',
  materialType: {
    image: '画像',
    video: '動画',
  },
  content: {
    prepend:
      'リストにはMindworksが作成した素材が含まれており、直接プッシュできます。プッシュ後、素材は直接アップロードされます',
    append: 'の素材ライブラリに。',
  },
  selfService: 'Mintegral広告主セルフサービス広告プラットフォーム',
  searchFilterLabel: {
    search: '検索',
    productName: '製品名',
    templateName: 'クリエイティブコンセプト名',
    templateId: 'リエイティブコンセプトID',
    materialName: 'プロジェクト名',
    materialId: 'プロジェクトID',
    versionName: 'バージョン名',
    dcoId: 'DCOID',
    network: 'チャネルを選択',
  },
  batchPush: '一括プッシュ',
  playableType: {
    normal: '通常の制作',
    dco: 'DCO制作',
  },
  table: {
    column: {
      playableName: '製品情報/テンプレート名',
      versionCount: 'バージョン数',
      materialType: 'テンプレートタイプ',
      language: '言語',
      network: 'チャネル',
      platform: 'プラットフォーム',
      options: '操作',
      versionName: 'バージョン名',
      deliveryTime: '納期',
      dcoId: 'DCOID',
      materialName: '製品名/テンプレートID',
      hideVersion: 'バージョンを閉じる',
      showVersion: 'バージョンを展開',
    },
    loadMore: 'もっと読み込む',
  },
}
